/* Informational entry points only. Selection remains in pt-style-guide.js. */
(function () {
  'use strict';
  if (window.ptStyleExploreBound) return;
  window.ptStyleExploreBound = true;
  var types = [['WOMAN', 'Women'], ['GIRL', 'Girls'], ['MAN', 'Men'], ['BOY', 'Boys']];

  function guides() {
    return types.map(function (type) {
      return { key: type[0], label: type[1], guide: window.PTStyleCatalog.resolve(type[0]) };
    }).filter(function (entry) { return entry.guide && entry.guide.styles.length; });
  }

  // Presentation order only: guides() and Explore Mode remain universal.
  function railStyles(entries, relationship) {
    var defaults = [];
    entries.forEach(function (entry) {
      entry.guide.styles.forEach(function (style) {
        var source = style.card.querySelector('[data-pt-style-image] img, [data-pt-style-image] template[data-pt-guide-image]');
        if (source) defaults.push({ entry: entry, style: style, source: source });
      });
    });
    var sequences = {
      couple: ['WOMAN', 'MAN'],
      'mother-daughter': ['WOMAN', 'GIRL'],
      'mother-son': ['WOMAN', 'BOY'],
      'father-daughter': ['MAN', 'GIRL'],
      'father-son': ['MAN', 'BOY'],
      siblings: ['GIRL', 'BOY'],
      family: ['WOMAN', 'MAN', 'GIRL', 'BOY', 'WOMAN', 'GIRL'],
      elderly: ['WOMAN', 'MAN']
    };
    var sequence = sequences[relationship];
    if (!sequence) return defaults;
    var first = [];
    var selected = new Set();
    // Each lookup takes the next image in the catalog's existing sorted order.
    // Repeat until six or relevant styles run out, including uneven type counts.
    while (first.length < 6) {
      var previousLength = first.length;
      sequence.forEach(function (key) {
        if (first.length === 6) return;
        var next = defaults.find(function (item) {
          return item.entry.key === key && !selected.has(item);
        });
        if (next) { first.push(next); selected.add(next); }
      });
      if (first.length === previousLength) break;
    }
    // Default order fills any shortfall and supplies the entire remaining rail.
    return first.concat(defaults.filter(function (item) { return !selected.has(item); }));
  }

  function refresh() {
    var entries = guides();
    document.querySelectorAll('[data-pt-style-explore-link]').forEach(function (link) {
      link.hidden = !entries.length;
    });
    document.querySelectorAll('[data-pt-style-strip]').forEach(function (strip) {
      if (strip.dataset.ptStyleReady) return;
      var rail = strip.querySelector('[data-pt-style-rail]');
      var previews = railStyles(entries, strip.dataset.ptStyleRelationship);
      if (strip.hasAttribute('data-pt-style-home-variety')) {
        // Editorial preview only: choose existing eligible records, never order identity.
        var women = previews.filter(function (item) { return item.entry.key === 'WOMAN'; });
        var featured = [
          women.filter(function (item) { return /cami/i.test(item.style.name) && /short/i.test(item.style.name); }),
          women.filter(function (item) { return /ruffl/i.test(item.style.name) && /dress/i.test(item.style.name); })
        ];
        var firstFour = previews.slice(0, 4);
        var selected = new Set(firstFour);
        var lastTwo = featured.map(function (matches) {
          var choice = matches.length === 1 && !selected.has(matches[0]) ? matches[0] : null;
          if (!choice) choice = previews.slice(4).find(function (item) { return !selected.has(item); });
          if (choice) selected.add(choice);
          return choice;
        }).filter(Boolean);
        previews = firstFour.concat(lastTwo);
      }
      var previewLimit = Number(strip.dataset.ptStyleLimit);
      if (previewLimit > 0) previews = previews.slice(0, previewLimit);
      previews.forEach(function (item) {
        var previewSizes = strip.dataset.ptStyleImageSizes || '80px';
        var previewWidths = strip.dataset.ptStyleImageSizes ? [160, 240, 320, 400, 480, 600] : [80, 120, 160, 240, 300];
        var image = window.PTStyleCatalog.imageFrom(item.source, previewSizes, previewWidths);
        image.alt = item.entry.label + ' — ' + item.style.name;
        if (strip.hasAttribute('data-pt-style-clickable')) {
          var trigger = document.createElement('button');
          trigger.type = 'button';
          trigger.className = 'pt-home-styles__preview';
          trigger.setAttribute('data-pt-style-explore', '');
          trigger.setAttribute('aria-haspopup', 'dialog');
          trigger.setAttribute('aria-controls', 'modal-pt-style-guide');
          trigger.setAttribute('aria-label', 'Explore styles — ' + image.alt);
          trigger.appendChild(image);
          rail.appendChild(trigger);
        } else {
          rail.appendChild(image);
        }
      });
      var total = entries.reduce(function (sum, entry) {
        return sum + entry.guide.styles.length;
      }, 0);
      strip.querySelector('[data-pt-style-total]').textContent = total + ' styles across women, men, girls & boys';
      var exploreCTA = strip.querySelector('[data-pt-style-cta]');
      if (exploreCTA) exploreCTA.textContent = 'Explore all ' + total + ' styles →';
      rail.hidden = !rail.children.length;
      strip.hidden = !entries.length;
      if (entries.length) strip.dataset.ptStyleReady = 'true';
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-pt-style-explore]');
    if (!trigger) return;
    var modal = document.getElementById('modal-pt-style-guide');
    var entries = guides();
    if (!modal || typeof modal.open !== 'function' || !entries.length) return;
    event.preventDefault();
    var content = modal.querySelector('[data-pt-style-content]');
    var navigation = document.createElement('div');
    navigation.className = 'pt-style-explore-types';
    navigation.setAttribute('role', 'group');
    navigation.setAttribute('aria-label', 'Browse styles by customer type');
    var body = document.createElement('div');
    content.replaceChildren(navigation, body);
    modal.querySelector('#pt-style-guide-title').textContent = 'Explore Styles';

    function show(entry) {
      body.replaceChildren(entry.guide.template.content.cloneNode(true));
      var carousel = body.querySelector('.pt-style-cards');
      carousel.setAttribute('aria-label', entry.label + ' styles');
      carousel.replaceChildren.apply(carousel, entry.guide.styles.map(function (style) {
        var card = style.card.cloneNode(true);
        card.querySelectorAll('[data-pt-style-select], [data-pt-style-current]').forEach(function (action) { action.remove(); });
        return card;
      }));
      window.PTStyleCatalog.hydrateImages(body);
      navigation.querySelectorAll('button').forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.customerType === entry.key));
      });
      var cards = Array.from(carousel.children);
      var indicator = body.querySelector('[data-pt-style-position]');
      function updatePosition() {
        var left = carousel.getBoundingClientRect().left;
        var index = cards.reduce(function (best, card, i) {
          return Math.abs(card.getBoundingClientRect().left - left) < Math.abs(cards[best].getBoundingClientRect().left - left) ? i : best;
        }, 0);
        indicator.hidden = cards.length < 2;
        indicator.textContent = (index + 1) + ' / ' + cards.length;
      }
      carousel.addEventListener('scroll', updatePosition, { passive: true });
      updatePosition();
    }

    entries.forEach(function (entry) {
      var button = document.createElement('button');
      button.type = 'button';
      button.dataset.customerType = entry.key;
      button.textContent = entry.label + ' ' + entry.guide.styles.length;
      button.addEventListener('click', function () {
        show(entry);
        // The theme focus trap caches its elements; refresh after replacing cards.
        trapFocus(modal, button);
      });
      navigation.appendChild(button);
    });
    body.addEventListener('click', function (event) {
      var button = event.target.closest('[data-pt-style-view]');
      if (!button) return;
      var card = button.closest('[data-pt-style-code]');
      card.querySelectorAll('[data-pt-style-image]').forEach(function (image) {
        image.hidden = image.dataset.ptStyleImage !== button.dataset.ptStyleView;
      });
      window.PTStyleCatalog.hydrateImages(card, true);
      card.querySelectorAll('[data-pt-style-view]').forEach(function (view) {
        view.setAttribute('aria-pressed', String(view === button));
      });
    });
    show(entries[0]);
    modal.open(trigger);
    modal.querySelector('.modal__content').scrollTop = 0;
  });

  refresh();
  // Collection filtering/pagination and PDP section updates replace their markup.
  new MutationObserver(function (records) {
    if (records.some(function (record) {
      return Array.from(record.addedNodes).some(function (node) {
        return node.nodeType === 1 && (node.matches('[data-pt-style-strip], [data-pt-style-explore-link], #modal-pt-style-guide') || node.querySelector('[data-pt-style-strip], [data-pt-style-explore-link], #modal-pt-style-guide'));
      });
    })) refresh();
  }).observe(document.body, { childList: true, subtree: true });
})();
